import { FormattedMessage } from "react-intl";
import VenueContextSelect from "components/data/VenueSelect/VenueContextSelect";
import { useVenueContext } from "contexts/VenueContext";
import { Box } from "components/styles";
import LoginLayout from "components/layouts/LoginLayout";
import Button from "@ticketingplatform/ui/dist/components/atoms/Button";
import { Link } from "@react-navigation/native";
import { PATHS, SCREENS } from "navigation/consts";
import { useAuth } from "hooks/useAuth";

import * as Styled from "./styles";

const VenueLogin: React.FC = () => {
  const { signOut } = useAuth();
  const { venue } = useVenueContext();

  return (
    <LoginLayout
      title={<FormattedMessage defaultMessage="CHOOSE VENUE" />}
      withLogo
      bottomContent={
        <Box px="1.5rem" width="1000%">
          <Button
            $fullW
            type="button"
            $mode="tertiary"
            size="large"
            onClick={async () => {
              await signOut();

              window.location.pathname = PATHS.Login;
            }}
          >
            <FormattedMessage defaultMessage="Log Out" />
          </Button>
        </Box>
      }
    >
      <Box py="1.5rem">
        <Styled.VenueLoginSelectWrapper>
          <VenueContextSelect />
        </Styled.VenueLoginSelectWrapper>
        <Box pt="1.25rem">
          <Link to={{ screen: SCREENS.EventList }}>
            <Button
              $fullW
              type="button"
              $mode="tertiary"
              size="large"
              disabled={!venue}
            >
              <FormattedMessage defaultMessage="Continue" />
            </Button>
          </Link>
        </Box>
      </Box>
    </LoginLayout>
  );
};

export default VenueLogin;
